export class Guard {
  public static isDefined(propName: string, propVal: any) {
    if (!propVal) {
      throw Error("The " + propName + " was not specified.");
    }
  }
}
